const baseSize = 8 // px

export const size = (factor: number) => `${factor * baseSize}px`
